module.exports = __webpack_public_path__ + "media/src/assets/buenas-ideas-f98f1751415f661b57429da813be076a.svg";